import { isAddress } from "ethers"

export const formatNumberWithComma = (num: number) => {
    return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
}

// numberFormat
// european style number format with comma and dot (ex: 1.000,00)
export const numberFormat = (num: number = 0, isHide = false) => {
    const value = num
        ?.toFixed(2)
        .replace(".", ",")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    if (isHide) return hideNumber(value)
    return value
}

export const formatDateTime = (dateString: string) => {
    const date = new Date(dateString)
    const formattedDate = date.toLocaleDateString("en-CA")
    const formattedTime = date.toLocaleTimeString("en-GB")
    return `${formattedDate} ${formattedTime}`
}

export function formatNumberWithCommas(number: number): string {
    if (number === undefined || number === null) {
        console.error("Invalid number:", number)
        return ""
    }
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
}

export function formatXplAmount(value: number | string): string {
    const parsed = typeof value === "string" ? parseFloat(value) : value
    if (!Number.isFinite(parsed)) return "0.00"
    return parsed.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    })
}

export const hideNumber = (value: string) => {
    var total = value.replace(/\d/g, "*")
    return total
}

export const generateRandomString = (length: number) => {
    let result = ""
    const characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789"
    const charactersLength = characters.length
    let counter = 0
    while (counter < length) {
        result += characters.charAt(
            Math.floor(Math.random() * charactersLength)
        )
        counter += 1
    }
    return result
}

export function extractNumbers(inputArray) {
    const resultArray = inputArray?.map((item) => {
        const match = item.match(/€(\d+)/)
        return match ? Number(match[1]) : null
    })
    return resultArray
    /* if array ["LlvUDVbNzB2 - €23", "HC0qdQNmZKh - €23"] then result ["23", "23"] */
}

export function extractAlphanumeric(inputArray) {
    const resultArray = inputArray?.map((item) => {
        const match = item.match(/([A-Za-z0-9]+) -/)
        return match ? match[1] : null
    })
    return resultArray
    /* if array ["LlvUDVbNzB2 - €23", "HC0qdQNmZKh - €23"] then result ["LlvUDVbNzB2", "HC0qdQNmZKh"] */
}

export function formatDateToYYYYMMDD(dateObj) {
    if (
        dateObj &&
        dateObj.$y !== undefined &&
        dateObj.$M !== undefined &&
        dateObj.$D !== undefined
    ) {
        const year = dateObj.$y
        const month = String(dateObj.$M + 1).padStart(2, "0") // Month is zero-based
        const day = String(dateObj.$D).padStart(2, "0")

        return `${year}-${month}-${day}`
    } else {
        console.error("Invalid date object:", dateObj)
        // Handle the invalid date object as needed
        return null // or throw an error
    }
}

export const openNewTab = (url: string) => {
    const a = document.createElement("a")
    a.href = url
    a.target = "_blank"
    a.style.display = "none"

    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
}

export const isValidEmail = (email: string): boolean => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    return emailRegex.test(email)
}

export const otpValidaty = (vCode: Array<string>) => {
    const otp = vCode.join("") ? vCode.join("") : null
    if (!otp || otp.length < 6 || otp.length > 6) {
        return "Invalid OTP length"
    }
}

export const formatAmount = (amount) => {
    if (typeof amount === "string") {
        return Number(amount)?.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        })
    } else if (typeof amount === "number") {
        return amount?.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        })
    } else {
        return amount
    }
}

export const getTableIndexNumber = ({
    index,
    limit,
    page,
}: {
    page: number
    index: number
    limit: number
}) => {
    return (page - 1) * limit + (index + 1)
}

export const convertFileToBase64 = async (file: File): Promise<string> => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result as string)
        reader.onerror = (error) => reject(error)
    })
}
export const truncateMiddle = (str: string, visibleChars = 6): string => {
    if (!str || str.length <= visibleChars * 2) return str
    return `${str.slice(0, visibleChars)}...${str.slice(-visibleChars)}`
}
export function formatNumberWithoutRoundOff(
    value: number | string,
    decimal: number
): string {
    const str = typeof value === "number" ? value.toString() : value
    if (!str?.includes(".")) {
        return `${str}.00`
    }
    const [intPart, decimalPart] = str.split(".")
    const trimmedDecimal = decimalPart.slice(0, decimal)

    return `${intPart}.${trimmedDecimal.padEnd(2, "0")}`
}

export function formatNumberWithRoundOff(
    value: number | string,
    decimal: number = 6
): string {
    const num = typeof value === "string" ? parseFloat(value) : value
    if (isNaN(num)) return "0.00"
    const rounded = Number(num.toFixed(decimal))
    const [intPart, decimalPart = ""] = rounded.toString().split(".")
    if (decimalPart === "") {
        return `${intPart}.00`
    }
    return `${intPart}.${decimalPart}`
}

export function isValidPolygonAddress(address: string): boolean {
    return isAddress(address)
}

export function formatNumberSixDigit(num) {
    const value = Number(num)
    if (isNaN(value)) return num // handle invalid numbers

    const numStr = value.toString()

    if (!numStr.includes(".")) return value // no decimal → return as is

    const [intPart, decimalPart] = numStr.split(".")

    // Rule 1: If first decimal digit is NOT zero → keep max 6 decimals
    if (decimalPart[0] !== "0") {
        return parseFloat(value.toFixed(6))
    }

    // Rule 2: If first decimal digit is zero → return full number
    return value
}

export const convertToFile = (imageSrc: string) => {
    const arr = imageSrc.split(",")
    const mime = arr[0].match(/:(.*?);/)![1]
    const bstr = atob(arr[1])
    let n = bstr.length
    const u8arr = new Uint8Array(n)
    while (n--) u8arr[n] = bstr.charCodeAt(n)
    const newFile = new File([u8arr], "Image.jpg", {
        type: mime,
    })
    return newFile
}
